module.exports = __webpack_public_path__ + "img/meslo-dark.0afd3f6e.png";